import { persistStore } from 'redux-persist';
import type { Store } from 'redux';
let persistorInstance: ReturnType<typeof persistStore> | null = null;
export const initializePersistor = (store: Store) => {
  if (!persistorInstance) {
    persistorInstance = persistStore(store);
  }
  return persistorInstance;
};
export const getPersistor = () => persistorInstance;